import { of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { App, AppData } from '../data/apps';

@Injectable()
export class AppService extends AppData {
  private apps: App[] = [];

  getApps(): Observable<App[]> {
    return observableOf(this.apps);
  }
}
